<template>
  <q-card class="project-card" :style="{ 'border-color': project.color_hex }">
    <q-card-title class="overflow-hidden cursor-pointer" @click.native="handleViewProject">
      <div class="row justify-between items-center">
        <div class="col-auto row items-center">
          <span class="q-title text-bold">{{ project.name }}</span>

          <div v-if="!project.active" class="on-right">
            <q-chip dense color="warning" text-color="white">{{ $t('archived') }}</q-chip>
          </div>
        </div>

        <div class="col-auto">
          <q-chip
            v-if="isNotStarted"
            color="white"
            text-color="faded"
            class="faded-tag q-px-sm"
            dense
            rounded
          >
            {{ $t('no_time_entries_badge') }}
          </q-chip>

          <q-chip
            v-else-if="isSettled"
            icon="check"
            color="white"
            text-color="positive"
            class="positive-tag q-px-sm"
            dense
            rounded
          >
            {{ $t('no_open_project_hours') }}
          </q-chip>

          <div v-else class="row items-center q-body-2">
            <q-icon name="timer" color="grey-6"/>
            <span class="on-right">{{ openHours }} {{ $tc('open_hour', openHours) }}</span>
          </div>
        </div>
      </div>
    </q-card-title>

    <q-card-main class="q-mt-md">
      <div class="row gutter-y-sm gutter-x-md">
        <div class="col-auto row items-center" v-if="hasCustomer">
          <q-icon name="business" color="grey-6"/>
          <span class="on-right">{{ customerName }}</span>
        </div>

        <div class="col-auto row items-center">
          <q-icon name="calendar_today" color="grey-6"/>
          <span class="on-right">{{ projectDate }}</span>

          <q-tooltip :delay="500" anchor="bottom middle" self="top middle">
            {{ $t('project_start_date') }}
          </q-tooltip>
        </div>
      </div>
    </q-card-main>
  </q-card>
</template>

<script>
  import { date } from 'quasar'
  import { getCustomerName } from 'src/utils/searchResultParser'
  import { mapGetters } from 'vuex'
  import parseDate from 'date-fns/parse'

  export default {
    props: {
      project: {
        required: true,
        type: Object
      }
    },

    computed: {
      ...mapGetters(['activeTeam']),

      hasCustomer () {
        return !!this.project.customer
      },

      customer () {
        return this.hasCustomer ? this.project.customer.data : null
      },

      customerName () {
        return getCustomerName(this.customer)
      },

      projectDate () {
        return date.formatDate(parseDate(this.project.created_at.date), this.$t('date_format'))
      },

      isNotStarted () {
        return this.totalHours === 0
      },

      isSettled () {
        return this.openHours === 0
      },

      openHours () {
        return this.project.statistics
          ? Math.ceil(this.project.statistics.data.open_seconds / (60 * 60))
          : 0
      },

      totalHours () {
        return this.project.statistics
          ? Math.ceil(this.project.statistics.data.total_seconds / (60 * 60))
          : 0
      },

      isActive () {
        return !!this.project.active
      }
    },

    methods: {
      handleViewProject () {
        this.$router.push({ name: 'project', params: { team: this.activeTeam.id, project: this.project.id } })
      }
    }
  }
</script>

<style lang="stylus" src="./project-card.styl"></style>
